import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * A utility function that combines class names with Tailwind CSS classes
 * and safely merges them to prevent style conflicts and duplications.
 *
 * @param inputs - Class values to be merged
 * @returns Merged class string
 */
export function classNames(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
